var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCategory3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2335 9.29167C11.9252 5.89167 7.26683 5.70833 8.39183 0.766667C8.47516 0.4 8.0835 0.116667 7.76683 0.308333C4.74183 2.09167 2.56683 5.66667 4.39183 10.35C4.54183 10.7333 4.09183 11.0917 3.76683 10.8417C2.2585 9.7 2.10016 8.05833 2.2335 6.88333C2.2835 6.45 1.71683 6.24167 1.47516 6.6C0.908496 7.46667 0.333496 8.86667 0.333496 10.975C0.650163 15.6417 4.59183 17.075 6.0085 17.2583C8.0335 17.5167 10.2252 17.1417 11.8002 15.7C13.5335 14.0917 14.1668 11.525 13.2335 9.29167ZM5.50016 13.4833C6.70016 13.1917 7.31683 12.325 7.4835 11.5583C7.7585 10.3667 6.6835 9.2 7.4085 7.31667C7.6835 8.875 10.1335 9.85 10.1335 11.55C10.2002 13.6583 7.91683 15.4667 5.50016 13.4833Z",
    fill: "#C9D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2335 9.29167C11.9252 5.89167 7.26683 5.70833 8.39183 0.766667C8.47516 0.4 8.0835 0.116667 7.76683 0.308333C4.74183 2.09167 2.56683 5.66667 4.39183 10.35C4.54183 10.7333 4.09183 11.0917 3.76683 10.8417C2.2585 9.7 2.10016 8.05833 2.2335 6.88333C2.2835 6.45 1.71683 6.24167 1.47516 6.6C0.908496 7.46667 0.333496 8.86667 0.333496 10.975C0.650163 15.6417 4.59183 17.075 6.0085 17.2583C8.0335 17.5167 10.2252 17.1417 11.8002 15.7C13.5335 14.0917 14.1668 11.525 13.2335 9.29167ZM5.50016 13.4833C6.70016 13.1917 7.31683 12.325 7.4835 11.5583C7.7585 10.3667 6.6835 9.2 7.4085 7.31667C7.6835 8.875 10.1335 9.85 10.1335 11.55C10.2002 13.6583 7.91683 15.4667 5.50016 13.4833Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategory3);
export default __webpack_public_path__ + "static/media/iconCategory3.df5e0104e815415fbf71f63e6ff8c7d5.svg";
export { ForwardRef as ReactComponent };